module.exports = __webpack_public_path__ + "static/media/let5.41fa372e.JPG";